module.exports = __webpack_public_path__ + "media/images/clients/lock-236eb3fd668098826a353c2bc346fa38.svg";